import {Divider} from "@/components/divider/Divider.tsx";
import {DropdownHeader} from "@/components/dropdown/subComponents/DropdownHeader/DropdownHeader.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";
import {
  DropdownButtonActionItem,
  ExternalLink,
  GroupTitle,
} from "@/pages/reports/sla/details/actions/SLAReportDropdownButtonActions.ts";

const ExternalLinkComp = ({href, target, text}: ExternalLink) => (
  <DropdownItem href={href} target={target}>
    {text}
  </DropdownItem>
);

const DropdownTitle = ({title, icon}: GroupTitle) => {
  const IconComp = icon;
  return (
    <DropdownHeader>
      <IconComp /> {title}
    </DropdownHeader>
  );
};

export interface DropdownButtonActionProps {
  items: DropdownButtonActionItem[];
}

export const SLAReportDropdownButtonAction = ({items}: DropdownButtonActionProps) => (
  <DropdownButton size={"large"} title={"Download"}>
    {items.map((item, idx) => (
      <div key={`item-${idx}`}>
        {Object.hasOwn(item, "href") && <ExternalLinkComp {...(item as ExternalLink)} />}
        {Object.hasOwn(item, "icon") && <DropdownTitle {...(item as GroupTitle)} />}
        {Object.hasOwn(item, "divider") && <Divider />}
      </div>
    ))}
  </DropdownButton>
);
